"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var batchEventBus_1 = __importDefault(require("../batchEventBus"));
var typings_1 = require("../typings");
var proxyHeaderExtractor = /request-id: (.*)(?:\n)?(?:failure-reason: (.*)(?:\n)?)?(?:failure-message: (.*)(?:\n)?)?/m;
var requestDetailsExtractor = /([0-9]{3}) (.*)\n((?:.|\n)*)/m;
function extractResponseHeaders(headerString) {
    if (!headerString) {
        return {};
    }
    return headerString
        .split('\n')
        .filter(function (chunk) { return chunk; })
        .reduce(function (map, headerLine) {
        var _a;
        var _b = headerLine.split(': '), name = _b[0], value = _b[1];
        if (!name || !value) {
            return map;
        }
        Object.assign(map, (_a = {},
            _a[name] = value,
            _a[name.toLowerCase()] = value,
            _a));
        return map;
    }, {});
}
exports.extractResponseHeaders = extractResponseHeaders;
function parseBody(headers, body) {
    var isJsonBody = headers['content-type'].includes('json');
    try {
        return isJsonBody ? JSON.parse(body) : body;
    }
    catch (error) {
        return body;
    }
}
exports.parseBody = parseBody;
function mapResponseChunks(_a) {
    var proxyHeaders = _a[0], details = _a[1], body = _a[2];
    var proxyMatches = proxyHeaderExtractor.exec(proxyHeaders);
    if (!proxyMatches) {
        return {
            failureReason: typings_1.FailureReason.Parser,
            failureMessage: 'SDK Parse Failed',
        };
    }
    var requestId = proxyMatches[1], reason = proxyMatches[2], message = proxyMatches[3];
    var response = {
        requestId: requestId,
        failureReason: reason,
        failureMessage: message,
    };
    var reasonWithoutResponse = reason === typings_1.FailureReason.Parser || reason === typings_1.FailureReason.Validation;
    if (reasonWithoutResponse) {
        return response;
    }
    var detailsMatches = requestDetailsExtractor.exec(details);
    if (!detailsMatches) {
        return response;
    }
    var status = detailsMatches[1], statusText = detailsMatches[2], headerString = detailsMatches[3];
    response.status = Number(status);
    response.statusText = statusText;
    response.headers = extractResponseHeaders(headerString);
    if (body) {
        response.data = parseBody(response.headers, body);
    }
    return response;
}
function mapEmitResponseChunk(chunk) {
    var response = mapResponseChunks(chunk.split('\n\n\n\n'));
    batchEventBus_1.default.emit(response.requestId, response);
    return response;
}
function handleResponse(proxyResponse) {
    return proxyResponse.data
        .split("--" + _1.BOUNDARY)
        .filter(function (chunk) { return chunk && chunk !== '--'; })
        .map(mapEmitResponseChunk);
}
exports.handleResponse = handleResponse;
exports.createGeneralErrorHandler = function (requests) {
    return function handleGeneralError(error) {
        requests.forEach(function (request) {
            return batchEventBus_1.default.emit(request.requestId, Promise.reject(error));
        });
        return [];
    };
};
